import { render, staticRenderFns } from "./F201.vue?vue&type=template&id=2991e49e&scoped=true"
import script from "./F201.vue?vue&type=script&lang=js"
export * from "./F201.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=2991e49e&prod&scoped=true&lang=css&external"
import style1 from "./F201.vue?vue&type=style&index=1&id=2991e49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991e49e",
  null
  
)

export default component.exports